import React, { useEffect, useState } from "react";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import Card from "@mui/material/Card";
import WarehouseLocationVm from "../viewmodel/WarehouseLocationVm";
import CBackDrop from "../../../basecomp/components/CBackDrop";
import { Box, styled } from "@mui/system";
import { useNavigate } from "react-router-dom";
import CAccordion from "../../../basecomp/components/CAccordion";
import CAuthPopUpBox from "../../../basecomp/components/CAuthPopUpBox";
import CButton from "../../../basecomp/components/CButton2";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";

const commonFontSize = ".9em";
const OrderBoxText = styled("div")({
  textAlign: "center",
  backgroundColor: "#3CB043",
  color: "white",
  padding: ".5em 3em",
  borderRadius: "0.7em 0.7em 0em 0em",
  fontSize: "1.2em",
  marginTop: "1em",
});

const WareHouseView = () => {
  const {
    wareHouseMaterialData,
    infoMatHeadData,
    terminal_id,
    storage_loc,
    loading,
    storage_bin,
    gsOneToolRedirectMethod,
    popUpBox,
    url_terminal
  } = WarehouseLocationVm();

  const [assetData, setAssetData] = useState([]);
  const [infoRowData, setInfoRowData] = useState([]);
  const navigate=useNavigate()
  useEffect(() => {
    if (storage_loc == 1120 && url_terminal == 1260) {
      navigate(`/warehouse/whs-location-info?terminal_id=1121&storage_bin=${storage_bin}&storage_loc=${storage_loc}`);
    }
  }, []);

  const handleCount = () => {
    navigate(
      `/warehouse/whs-location-info/counting?terminal_id=${terminal_id}&storage_bin=${storage_bin}&storage_loc=${storage_loc}`
    );
  };
  useEffect(() => {
    setAssetData([
      [
        {
          name: "Plant ID",
          value: terminal_id,
        },
      ],
      [
        {
          name: "Storage Location",
          value: storage_loc,
        },
      ],
      [
        {
          name: "Storage Bin Group",
          value: storage_bin,
        },
      ],
    ]);
    setInfoRowData([
      { value: `name`, type: "T" },
      { value: `value`, type: "T" },
    ]);
  }, [terminal_id, storage_loc, storage_bin]);

  return (
    <Grid
      item
      xs={10}
      sm={10}
      md={10}
      lg={10}
      xl={10}
      sx={{ margin: "5em 0.5em 0.5em 0.5em" }}
    >
      {popUpBox ? (
        <CAuthPopUpBox CText="You are not authorized to view the details of this asset" />
      ) : null}
      <CBackDrop cOpen={loading} />

      <Card sx={{ padding: "0.5em" }}>
        <div
          style={{ display: "flex", justifyContent: "end", alignItems: "end" }}
        >
          <CButton
            cSrc={<FactCheckOutlinedIcon fontSize="small" />}
            cTooltipText={"Click here to start the counting"}
            cOnClick={handleCount}
            cFullWidth={true}
            cDisabled={wareHouseMaterialData?.length===0}
          />
        </div>
        <CAccordion
          CHeader="General Info"
          CData={assetData}
          CRows={infoRowData}
        />

        <OrderBoxText>Inventory Location Details</OrderBoxText>
        <Box
          sx={{
            border: "1px solid #3CB043",
            borderRadius: "0 0 1em 1em",
            overflowX: "auto",
            whiteSpace: "nowrap",
            marginBottom: "3em",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          <Table sx={{ minWidth: "650px" }}>
            <TableHead>
              <TableRow>
                {infoMatHeadData.map((header, index) => (
                  <TableCell
                    key={index}
                    sx={{
                      fontWeight: "bold",
                      padding: "6px 24px",
                      fontSize: commonFontSize,
                    }}
                  >
                    {header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {wareHouseMaterialData?.map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  {Object.keys(row).map((colKey, colIndex) => (
                    <TableCell
                      key={colIndex}
                      sx={{ padding: "8px 24px", fontSize: commonFontSize }}
                    >
                      {colKey === "material_no" ? (
                        <button
                          onClick={() =>
                            gsOneToolRedirectMethod(row.material_no)
                          }
                          style={{
                            background: "none",
                            border: "none",
                            color: "blue",
                            textDecoration: "underline",
                            cursor: "pointer",
                            padding: "0",
                            fontSize: "inherit",
                            fontFamily: "inherit",
                          }}
                        >
                          {row[colKey]}
                        </button>
                      ) : (
                        row[colKey]
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
              {wareHouseMaterialData?.length === 0 && (
                <TableRow>
                  <TableCell
                    colSpan={wareHouseMaterialData.length}
                    sx={{ textAlign: "center" }}
                  >
                    No data present
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Box>
      </Card>
    </Grid>
  );
};

export default WareHouseView;
